export default "__VITE_ASSET__DYwTs6B7__"